import React from 'react';
import { Tooltip } from '@mui/material';
import styles from '../../styles/query/ModeToggle.module.scss';

/**
 * Mode Toggle Component
 * 
 * Toggles between UI mode (Basic) and Advanced mode (JQL)
 * 
 * @param {string} mode - Current mode: 'ui' | 'advanced'
 * @param {boolean} isComplex - Whether the current query is too complex for UI mode
 * @param {function} onModeChange - Handler for mode change
 */
export function ModeToggle({ mode, isComplex = false, onModeChange }) {
  const handleChange = (newMode) => {
    // If trying to switch to UI mode but query is complex, block it
    if (newMode === 'ui' && isComplex && mode === 'advanced') {
      // Don't allow transition - Basic button should be disabled
      return;
    }
    onModeChange(newMode);
  };
  
  // Disable Basic button if query is complex
  const uiDisabled = isComplex && mode === 'advanced';
  
  return (
    <div className={styles.toggleGroup} role="group" aria-label="query mode">
      <Tooltip 
        title={uiDisabled ? 'Cannot switch to Basic mode. Query is too complex.' : 'Basic filter mode'}
        arrow
      >
        <span className={styles.tooltipWrapper}>
          <button
            type="button"
            className={`${styles.toggleButton} ${mode === 'ui' ? styles.selected : ''}`}
            onClick={() => handleChange('ui')}
            disabled={uiDisabled}
            aria-label="basic mode"
            aria-pressed={mode === 'ui'}
          >
            Basic
          </button>
        </span>
      </Tooltip>
      <Tooltip 
        title="Advanced query mode"
        arrow
      >
        <button
          type="button"
          className={`${styles.toggleButton} ${mode === 'advanced' ? styles.selected : ''}`}
          onClick={() => handleChange('advanced')}
          aria-label="advanced mode"
          aria-pressed={mode === 'advanced'}
        >
          Advanced
        </button>
      </Tooltip>
    </div>
  );
}

export default ModeToggle;

